import React from 'react';
import { SafeImg } from '../../SafeImg';
import { Btn, H1, Eyebrow, tidFor, E } from './_shared';

/* ════════════════════════════════════════════════════════════════════════
 * NEW BLOCK TYPE — data_table (pricing tier table, feature spec, comparison)
 *
 * Iter 175c — Section Audit. title · tagline · every row's tier/usage/
 * price (or name/description/value), every column header, aside_label/
 * text and CTA label are inline-editable.
 * ════════════════════════════════════════════════════════════════════════ */
export function DataTableBlock({ block, theme, E: EProps = {} }) {
  const { onEdit } = EProps;
  const c = block.content || {};
  const layout = block.layout || 'pay-as-you-go';
  const rows = c.rows || Array.from({length:5}).map((_,i)=>({ tier:`Tier ${i+1}`, usage:`${(i+1)*100} units`, price:`$${(i+1)*10}` }));
  const cols = c.columns || ['Tier','Usage','Price'];

  if (layout === 'feature-spec') {
    return (
      <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
        <div className="max-w-4xl mx-auto">
          <E block={block} onEdit={onEdit} field="title" value={c.title || "What's Inside?"} tag="h2" className="text-3xl md:text-4xl font-bold text-center mb-10" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
          <div className="border border-gray-200 rounded-xl overflow-hidden" style={{ borderRadius: theme.radius || 12 }}>
            {rows.map((r,i)=>(
              <div key={i} className={`grid grid-cols-3 px-6 py-4 ${i%2===0?'bg-gray-50':''} ${i!==rows.length-1?'border-b border-gray-100':''}`}>
                <E block={block} onEdit={onEdit} field={`rows.${i}.tier`} value={r.tier || r.name || ''} tag="span" className="text-xs uppercase tracking-wider opacity-60 font-bold" placeholder="Label" />
                <E block={block} onEdit={onEdit} field={`rows.${i}.usage`} value={r.usage || r.description || ''} tag="span" className="text-sm" placeholder="Value" />
                <E block={block} onEdit={onEdit} field={`rows.${i}.price`} value={r.price || r.value || ''} tag="span" className="text-sm text-right font-bold" placeholder="$0" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  // pay-as-you-go (default) + comparison fallback
  return (
    <section data-block-type={block.type} data-layout={block.layout || "default"} className="px-6 py-16" style={{ background: theme.bg, color: theme.ink }}>
      <div className="max-w-4xl mx-auto">
        <E block={block} onEdit={onEdit} field="title" value={c.title || 'Pay as you go'} tag="h2" className="text-2xl md:text-3xl font-bold" style={{ fontFamily: theme.headingFont }} placeholder="Headline" />
        <E block={block} onEdit={onEdit} field="tagline" value={c.tagline || ''} tag="p" className="mt-2 opacity-70" placeholder="Tagline" />
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2 border border-gray-200 rounded-xl overflow-hidden">
            <table className="w-full text-left text-sm">
              <thead className="bg-gray-50"><tr>{cols.map((col,i)=>(
                <th key={i} className="px-4 py-3 text-xs uppercase tracking-wider opacity-60">
                  <E block={block} onEdit={onEdit} field={`columns.${i}`} value={col} tag="span" placeholder="Column" />
                </th>
              ))}</tr></thead>
              <tbody>{rows.map((r,i)=>(
                <tr key={i} className={i%2===0?'':'bg-gray-50/50'}>
                  <td className="px-4 py-3"><E block={block} onEdit={onEdit} field={`rows.${i}.tier`} value={r.tier || ''} tag="span" placeholder="Tier" /></td>
                  <td className="px-4 py-3"><E block={block} onEdit={onEdit} field={`rows.${i}.usage`} value={r.usage || ''} tag="span" placeholder="Usage" /></td>
                  <td className="px-4 py-3 font-bold"><E block={block} onEdit={onEdit} field={`rows.${i}.price`} value={r.price || ''} tag="span" placeholder="$0" /></td>
                </tr>
              ))}</tbody>
            </table>
          </div>
          <div className="p-6 rounded-xl text-white" style={{ background: theme.accent || '#2DD4BF', borderRadius: theme.radius || 12 }}>
            <E block={block} onEdit={onEdit} field="aside_label" value={c.aside_label || 'Easy Start'} tag="p" className="text-xs uppercase tracking-wider opacity-90 font-bold" placeholder="Aside label" />
            <E block={block} onEdit={onEdit} field="aside_text" value={c.aside_text || 'Sign up to lock in your tier rate today.'} tag="p" className="mt-3 text-sm opacity-95" placeholder="Aside text" />
            <span className="mt-5 inline-block px-5 py-2.5 rounded-full text-xs font-bold uppercase bg-white text-gray-900 cursor-text">
              <E block={block} onEdit={onEdit} field="aside_button" value={c.aside_button || 'Sign Up'} tag="span" placeholder="Button" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
